import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { throttleTime } from 'rxjs/operators'; // Thêm để chặn popup bị trùng
import { AccountService, DeviceTokenDto } from 'src/app/proxy/account';

@Injectable({ providedIn: 'root' })
export class FirebaseNotificationService {
    currentMessage = new BehaviorSubject(null);

    constructor(
        private afMessaging: AngularFireMessaging,
        private accountService: AccountService,
    ) {
        // this.afMessaging.messages.subscribe((msg) => {
        // <<< Sửa dòng trên để chặn popup thông báo bị trùng
        this.afMessaging.messages
            .pipe(
                throttleTime(1000), // Trong vòng 1 giây, nếu Firebase bắn liên tiếp nhiều tin, CHỈ NHẬN tin đầu tiên
            )
            .subscribe((msg) => {
                // >>>
                console.log('Foreground message:', msg);
                this.currentMessage.next(msg);
            });
    }

    requestPermission() {
        this.afMessaging.requestToken.subscribe(
            (token) => {
                console.log('FCM Token:', token);
                // Gửi token về server nếu cần
                const deviceToken: DeviceTokenDto = {
                    device_token: token,
                };
                this.accountService
                    .putDeviceToken(deviceToken)
                    .subscribe(() => {});
            },
            (error) => {
                console.error('Permission denied or error occurred:', error);
            },
        );
    }
}
